"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPetFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M13.498 9.548c.138.115.264.246.374.39l4.602 6c.828 1.078.66 2.651-.374 3.514a2.337 2.337 0 01-1.498.548H7.398C6.074 20 5 18.88 5 17.5c0-.568.185-1.12.525-1.562l4.603-6c.827-1.078 2.336-1.253 3.37-.39zM19.5 8a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-15 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm11-5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-7 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5z' }))); };
exports.default = SvgPetFilled;
//# sourceMappingURL=PetFilled.js.map